import Vue from 'vue'
import Router from 'vue-router'
import Sqmsg from '@/pages/sqmsg/sqmsg'
import Sqroom from '@/pages/sqroom/sqroom'
import Errcon from '@/pages/errcon/errcon'
import Chiocesq from '@/pages/chiocesq/chiocesq'
import Searchlist from '@/pages/searchlist/searchlist'
import Aroundlist from '@/pages/aroundlist/aroundlist'
import Arounddetail from '@/pages/arounddetail/detail'
import Jdlist from '@/pages/jdlist/jdlist'
import Map from '@/pages/map/map'
import Addmsg from '@/pages/addmsg/addmsg'
import Mcenter from '@/pages/mcenter/mcenter'
import Records from '@/pages/records/records'
import Xxdetail from '@/pages/xxdetail/xxdetail'
import Crrecords from '@/pages/crrecords/crrecords'
import Zqzmg from '@/pages/zqzmg/zqzmg'
import Addnew from '@/pages/addnew/addnew'
import Areamsg from '@/pages/areamsg/areamsg'
import Pcheck from '@/pages/passcheck/passcheck'
import Gllists from '@/pages/gllist/gllist'
import Support from '@/pages/support/support'
import Svote from '@/pages/svote/svote'
import Chiocevote from '@/pages/chiocevote/chiocevote'
// import Chiocelist from '@/pages/chiocelist/chiocelist'

Vue.use(Router)
export default new Router({
  // mode:'history',
  // base:'/htmls/community/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component:(resolve)=>{
        return require(['@/pages/index'], resolve)
      }
    },
    {
      path: '/sqmsg',
      name: 'Sqmsg',
      component: Sqmsg,
    },
    {
      path: '/sqroom',
      name: 'Sqroom',
      component: Sqroom
    },
    {
      path: '/errcon',
      name: 'Errcon',
      component: Errcon
    },
    {
      path:'/chiocesq',
      name:'Chiocesq',
      component:Chiocesq
    },
    {
      path:'/search',
      name:'Searchlist',
      component:Searchlist
    },
    {
      path:'/around',
      name:'Aroundlist',
      component:Aroundlist
    },
    {
      path:'/adetail',
      name:'Arounddetail',
      component:Arounddetail
    },
    {
      path:'/jdlist',
      name:'Jdlist',
      component:Jdlist
    },
    {
      path:'/map',
      name:'Map',
      component:Map
    },
    {
      path:'/addmsg',
      name:'Addmsg',
      component:Addmsg
    },
    {
      path:'/mcenter',
      name:'Mcenter',
      component:Mcenter
    },
    {
      path:'/records',
      name:'Records',
      component:Records
    },
    {
      path:'/xxdetail',
      name:'Xxdetail',
      component:Xxdetail
    },
    {
      path:'/crrecords',
      name:'Crrecords',
      component:Crrecords
    },
    {
      path:'/zqzmg',
      name:'Zqzmg',
      component:Zqzmg
    },
    {
      path:'/addnew',
      name:'Addnew',
      component:Addnew
    },
    {
      path:'/areamsg',
      name:'Areamsg',
      component:Areamsg
    },
    {
      path:'/pcheck',
      name:'Pcheck',
      component:Pcheck
    },{
      path:'/gllist',
      name:'Gllist',
      component:Gllists
    },{
      path:'/support',
      name:'Support',
      component:Support
    },{
      path:'/vote',
      name:'Vote',
      component:(resolve)=>{
        return require(['@/pages/vote/vote'], resolve)
      }
    },{
      path:'/svote',
      name:'Svote',
      component:Svote
    },{
      path:'/chiocevote',
      name:'Chiocevote',
      component:Chiocevote
    },{
      path:'/chiocelist',
      name:'Chiocelist',
      component: () => import('@/pages/chiocelist/chiocelist')
    },
    {
      path:'/login',
      name:'Login',
      component: () => import('@/component/login/')
    },
    {
      path:'/stick',
      name:'Stick',
      component:(resolve)=>{
        return require(['@/pages/sticks'], resolve)
      },
      meta: {
        title: '优惠券'
      },
      children:[
        {
          path:'/stick',
          name:'Stick',
          component:(resolve)=>{
            return require(['@/pages/sticks/stick'], resolve)
          }
        },
        {
          path:'/wwear/:id',
          name:'Wwear',
          component:(resolve)=>{
            return require(['@/pages/sticks/wwear'], resolve)
          }
        }
      ]
    },
    {
      path:'/sticksearch',
      name:'Ssearch',
      component:(resolve)=>{
        return require(['@/pages/sticksearch/sticksearch'], resolve)
      }
    },
    {
      path:'/searchlist',
      name:'Slist',
      component:(resolve)=>{
        return require(['@/pages/sticksearch/searchlist'], resolve)
      }
    },
    {
      path:'/stickdetail',
      name:'Sdetail',
      component:(resolve)=>{
        return require(['@/pages/stickdetail/stickdetail'], resolve)
      }
    },
    {
      path: '/detailRefresh',
      name: 'detailRefresh',
      component: (resolve) => {
        return require(['@/pages/stickdetail/refresh'], resolve)
      }
    },
    {
      path:'/tpush',
      name:'Tpush',
      component:(resolve)=>{
        return require(['@/pages/sticks/todaypush'], resolve)
      }
    },
    {
      path:'/rules',
      name:'Rules',
      component:(resolve)=>{
        return require(['@/pages/sticks/rules'], resolve)
      }
    },
    {
      path:'/salemore',
      name:'Salemore',
      component:(resolve)=>{
        return require(['@/pages/sticks/salemore'], resolve)
      }
    },
    {
      path:'/myorder', //活动订单列表
      name:'Myorder',
      component:(resolve)=>{
        return require(['@/pages/myorders'], resolve)
      }
    },
    {
      path:'/myorder/detail',
      name:'Myorderdetail',
      component:(resolve)=>{
        return require(['@/pages/myorders/detail'], resolve)
      },
    },
    {
      path:'/myorder/refund',
      name:'Myorderrefund',
      component:(resolve)=>{
        return require(['@/pages/myorders/refund'], resolve)
      },
    },
    {
      path:'/myorder/refunding',
      name:'Myorderrefunding',
      component:(resolve)=>{
        return require(['@/pages/myorders/rresult'], resolve)
      },
    },
    {
      path:'/myorder/my',
      name:'Mycenter',
      component:(resolve)=>{
        return require(['@/pages/myorders/my'], resolve)
      },
    },
    {
      path:'/myorder/deqorder',
      name:'deqOrder',
      component:(resolve)=>{
        return require(['@/pages/myorders/myorder'], resolve)
      }
    },
    {
      path:'/myorder/myprofit',
      name:'Profit',
      component:(resolve)=>{
        return require(['@/pages/myorders/myprofit'], resolve)
      },
    },
    {
      path:'/test',
      name:'Test',
      component:(resolve)=>{
        return require(['@/pages/test/test'], resolve)
      },
    },
    {
      path:'/myorder/pcenter',
      name:'Pcenter',
      component:(resolve)=>{
        return require(['@/pages/myorders/pcenter'], resolve)
      },
    },
    {
      path:'/myorder/mycenter',
      name:'Mycenter',
      component:(resolve)=>{
        return require(['@/pages/myorders/mycenter'], resolve)
      },
    },
    {
      path:'/activity',
      name:'Activity',
      component:(resolve)=>{
        return require(['@/pages/myactivity/index'], resolve)
      },
    },
    {
      path:'/albums',
      name:'Albums',
      component:(resolve)=>{
        return require(['@/pages/myactivity/collect'], resolve)
      },
    },
    {
      path:'/area',
      name:'Area',
      component:(resolve)=>{
        return require(['@/pages/myactivity/area'], resolve)
      },
    },
    {
      path:'/bussiness',
      name:'Bussiness',
      component:(resolve)=>{
        return require(['@/pages/myactivity/bussiness'], resolve)
      },
    },
    {
      path:'/activitylist',
      name:'Activitylist',
      component:(resolve)=>{
        return require(['@/pages/myactivity/activitylist'], resolve)
      }
    },
    {
      path:'/activity/kinds',
      name:'Kinds',
      component:(resolve)=>{
        return require(['@/pages/myactivity/kinds'], resolve)
      }
    },
    {
      path:'/activity/search',
      name:'Activitylist',
      component:(resolve)=>{
        return require(['@/pages/myactivity/searchlist'], resolve)
      }
    },
    {
      path:'/redbag/',
      name:'Redbag',
      component:() => import('@/pages/redbag/index')
    },
    {
      path:'/redbag/playinfo',
      name:'Playinfo',
      component:() => import('@/pages/redbag/playinfo')
    },
    {
      path:'/redbag/share',
      name:'Sharelist',
      component:() => import('@/pages/redbag/sharelist')
    },
    // 优惠券
    {
      path:'/coupon',
      name:'Coupon',
      component:() => import('@/pages/coupon/index')
    },
    // 优惠券活动可用列表
    {
      path:'/cactivity',
      name:'Cactivity',
      component:() => import('@/pages/coupon/cactivity')
    },
    // 优惠券规则
    {
      path:'/crules',
      name:'CouponRules',
      component:() => import('@/pages/coupon/rules')
    },
    // 领取优惠券
    {
      path:'/rcoupon',
      name:'recivecoupon',
      component:() => import('@/pages/coupon/rcoupon')
    },
    // 领取体验会员
    {
      path:'/lvip',
      name:'experiencevip',
      component:() => import('@/pages/coupon/experienceVip')
    },
    // 送会员
    {
      path:'/svip',
      name:'svip',
      component:() => import('@/pages/coupon/sVip')
    },
    // 商务合作
    {
      path:'/business',
      name:'Business',
      component:() => import('@/pages/coupon/business')
    },
    // 商务合作成功
    {
      path:'/bs',
      name:'Bs',
      component:() => import('@/pages/coupon/bs')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js